import { request } from "/src/utils/index.js";

export function Detail(params) {
  return request.get("tcm/medical/record/detail/b2b?id=" + params);
}
